import { Component, Input, forwardRef, Output, EventEmitter, ChangeDetectionStrategy, ChangeDetectorRef, inject } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Component({
    selector: 'app-toggle',
    templateUrl: './toggle.component.html',
    styleUrls: ['./toggle.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ToggleComponent implements ControlValueAccessor {
    private readonly changeDetectorRef = inject(ChangeDetectorRef);

    public get value() {
        return this._value;
    }

    @Input()
    public set value(value) {
        this._value = value;
        this._onChange(value);
        this._onTouched(value);
    }
    @Input() id: string;
    @Input() large: boolean;
    @Input() disable: boolean;

    @Output() change = new EventEmitter();

    private _value: boolean;

    registerOnChange(fn: any): void {
        this._onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this._onTouched = fn;
    }

    writeValue(value: boolean): void {
        if (value !== null) {
            this.value = value;
            this.changeDetectorRef.markForCheck();
        }
    }

    onChange(newValue: boolean): void {
        this.change.emit(newValue);
    }

    private _onChange: any = () => {};
    private _onTouched: any = () => {};
}
